export function dateStringToDate(dateString: string) {
  // replacing '-' to '/' due to Date implementation in some safari versions
  // which cannot parse dates in yyyy-mm-dd format
  // (eg. Mobile Safari 15.6.1 - https://app.rollbar.com/a/bumocare/fix/item/bumocare-app/365)
  return new Date(`${dateString.replace(/-/g, '/')} 00:00`);
}
